module.exports = __webpack_public_path__ + "img/2.67d8ed49.jpg";